import type { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { usePageMeta } from '../../hooks/usePageMeta';
import './LegalLayout.css';

interface LegalLayoutProps {
  title: string;
  /** Meta description for the page. */
  description: string;
  /** Route path, used for the canonical URL. */
  path: string;
  /** Human-readable date the text was last revised, e.g. "16 October 2026". */
  lastUpdated?: string;
  children: ReactNode;
}

function LegalLayout({ title, description, path, lastUpdated, children }: LegalLayoutProps) {
  usePageMeta(`${title} | EFSoft`, description, path);

  return (
    <div className="site">
      <Header />
      <main id="main-content" className="legal-main" tabIndex={-1}>
        <article className="legal-article">
          <header className="legal-header">
            <h1>{title}</h1>
            {lastUpdated && <p className="legal-subtitle">Last updated {lastUpdated}</p>}
          </header>
          <div className="legal-body">{children}</div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default LegalLayout;
